<template>
    <div>
        <nav-breadcrumb :menu="[{label: '材料打印清单'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :is-pagination-show="false"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
        <el-dialog v-if="dialogVisible" title="变更代理人"
                   :visible.sync="dialogVisible"
                   width="60%">
            <el-form :model="dataForm" :rules="{}" ref="dataForm" label-width="150px">
                <el-row>
                    <el-col>
                        <el-form-item label="是否变更代理人：" prop="taxFactor">
                            <el-checkbox v-model="dataForm.checked" false-label="N" true-label="Y"  style="width: 35%"></el-checkbox>
                        </el-form-item>
                        <el-form-item label="代理人：" prop="taxFactor">
                            <el-input v-model="dataForm.proxyPersonName"  style="width: 35%" :disabled="dataForm.checked=='N'" ></el-input>
                        </el-form-item>
                        <el-form-item label="代理人身份证：" prop="taxFactor">
                            <el-input v-model="dataForm.proxyPersonIC"  style="width: 35%" :disabled="dataForm.checked=='N'" ></el-input>
                        </el-form-item>
                        <el-form-item label="代理人电话：" prop="taxFactor">
                            <el-input v-model="dataForm.proxyPersonContactNo" style="width: 35%" :disabled="dataForm.checked=='N'" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="exportPdf2">打印</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    export default {
        name: "CustomerPrintDetail",
        data(){
            return{
                transactionId: this.$route.query['transactionId']||'',
                dataForm:{
                    proxyPersonName:'',
                    proxyPersonIC:'',
                    proxyPersonContactNo:'',
                    checked:'N'

                },
                dialogVisible:false,
                proxyPersonName:'',
                proxyPersonIC:'',
                proxyPersonContactNo:'',
                tableData: {
                    count: 0,
                    data: [
                        {
                            name:'借款合同',
                            url:'LoanContract',
                            type:'jasper'
                        },
                        {
                            name:'最高额抵押合同',
                            url:'DYHT',
                            type:'pdf'
                        },
                        {
                            name:'最高额抵押合同-抵押清单',
                            url:'DYHT-1',
                            type:'pdf'
                        },
                        {
                            name:'表三',
                            url:'',
                            type:'pdf'

                        },
                        {
                            name:'单位委托书',
                            url:'',
                            type:'pdf'
                        },
                        {
                            name:'贷款告知客户书',
                            url:'GZS',
                            type:'jasper'
                        },
                        {
                            name:'借款借据',
                            url:'JJ',
                            type:'pdf'
                        },

                    ]
                },
                page: 1,
                pageSize: 20,
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '文件名称',
                        field: 'name'
                    },
                    {
                        label: '操作',
                        opts: [
                            {
                                class: 'el-icon-download',
                                name: '下载',
                                clickHandler: (index, row)=>{
                                    if(row.name=='表三'||row.name=='单位委托书'){
                                        this.dialogVisible = true
                                        this.dataForm.proxyPersonName = this.proxyPersonName
                                        this.dataForm.proxyPersonContactNo = this.proxyPersonContactNo
                                        this.dataForm.proxyPersonIC = this.proxyPersonIC
                                        this.dataForm.url = row.url
                                        this.dataForm.type = row.type
                                    }else{
                                        this.exportPdf(index, row)
                                    }

                                },
                                conditions: row=> {
                                    return row.url !==''

                                }
                            },
                        ]
                    },

                ],

                actions: [
                ],
                filters: {
                    labelWidth: '150px',
                    form: {

                    },
                    columns: [


                    ],
                    onSubmit:()=>{

                    }
                }
            }
        },
        mounted() {
            this.getFinancingFang()
        },
        methods:{
            getFinancingFang : function () {
                xhr.getFinancingFang({
                    'fi.transactionId': this.$route.query['transactionId']
                }, res=>{
                    try{
                        if(res.data.status == 'success') {

                            const customerDetail = res.data.data
                            if(customerDetail.t__regionId=='JSWXWX'){
                                this.tableData.data[3].url='SQS'
                                this.tableData.data[4].url='WTS'
                            }else if(customerDetail.t__regionId=='JSWXJY'){
                                this.tableData.data[3].url='SQSJY'
                                this.tableData.data[4].url='WTSJY'
                            }else if(customerDetail.t__regionId.includes('JSCZCZ') || customerDetail.t__regionId.includes('JSCZWJ')){
                                this.tableData = {
                                    count: 0,
                                        data: [
                                        {
                                            name:'借款合同',
                                            url:'LoanContract',
                                            type:'jasper'
                                        },
                                        {
                                            name:'最高额抵押合同',
                                            url:'DYHT',
                                            type:'pdf'
                                        },
                                        {
                                            name:'最高额抵押合同-抵押清单',
                                            url:'DYHT-1',
                                            type:'pdf'
                                        },
                                        {
                                            name:'抵押登记申请书',
                                            url:'SQSCZ',
                                            type:'pdf'

                                        },
                                        {
                                            name:'办押委托书',
                                            url:'WTSCZ',
                                            type:'pdf'
                                        },
                                        {
                                            name:'承诺书',
                                            url:'CNSCZ',
                                            type:'pdf'
                                        },
                                        {
                                            name:'贷款告知客户书',
                                            url:'GZS',
                                            type:'jasper'
                                        },
                                        {
                                            name:'借款借据',
                                            url:'JJ',
                                            type:'pdf'
                                        },

                                    ]
                                }
                            }else if(customerDetail.t__regionId.includes('JSSZSIP')){
                                this.tableData = {
                                    count: 0,
                                    data: [
                                        {
                                            name:'借款合同',
                                            url:'LoanContract',
                                            type:'jasper'
                                        },
                                        {
                                            name:'最高额抵押合同',
                                            url:'DYHT',
                                            type:'pdf'
                                        },
                                        {
                                            name:'最高额抵押合同-抵押清单',
                                            url:'DYHT-1',
                                            type:'pdf'
                                        },
                                        {
                                            name:'抵押登记申请书',
                                            url:'SQSSZ',
                                            type:'pdf'

                                        },
                                        {
                                            name:'办押委托书',
                                            url:'WTSSZ',
                                            type:'pdf'
                                        },
                                       /* {
                                            name:'承诺书',
                                            url:'CNSCZ',
                                            type:'pdf'
                                        },*/
                                        {
                                            name:'贷款告知客户书',
                                            url:'GZS',
                                            type:'jasper'
                                        },
                                        {
                                            name:'借款借据',
                                            url:'JJ',
                                            type:'pdf'
                                        },

                                    ]
                                }
                            }
                            this.proxyPersonName = customerDetail.fi__proxyPersonName
                            this.proxyPersonContactNo = customerDetail.fi__proxyPersonContactNo
                            this.proxyPersonIC = customerDetail.fi__proxyPersonIC

                        }
                    }catch(e){}
                })
            },
            exportPdf: function (index, row) {
                try {

                    if(row.type=='pdf'){
                        /* window.open('/extended/markup/t/docs/financing/'+row.url+'.'+row.type+'?fi.transactionId='+this.$route.query['transactionId'])

                     }else if(row.url=='DYHT'){
                         window.open('/extended/markup/t/docs/financing/'+row.url+'.'+row.type+'?fi.transactionId='+this.$route.query['transactionId'])
                         setTimeout(()=> {
                             window.open('/extended/markup/t/docs/financing/'+row.url+'-1.'+row.type+'?fi.transactionId='+this.$route.query['transactionId'])
                         }, 500)
                     }else if(row.url=='WTS'){*/
                        window.open('/extended/markup/t/docs/financing/'+row.url+'.'+row.type+'?fi.transactionId='+this.$route.query['transactionId'])
                    }else {
                        window.open('/ix/fang/financing/'+row.url+'.'+row.type+'?transactionId='+this.$route.query['transactionId'])
                    }
                }
                catch (e) {

                }
            },
            exportPdf2: function () {
                try {
                        if(this.dataForm.checked=='Y'){
                            window.open('/extended/markup/t/docs/financing/'+this.dataForm.url+'.'+this.dataForm.type+'?fi.transactionId='+this.$route.query['transactionId']
                                +'&&proxyPersonName='+this.dataForm.proxyPersonName
                                +'&&proxyPersonContactNo='+this.dataForm.proxyPersonContactNo
                                +'&&proxyPersonIC='+this.dataForm.proxyPersonIC)
                        }else {
                            window.open('/extended/markup/t/docs/financing/'+this.dataForm.url+'.'+this.dataForm.type+'?fi.transactionId='+this.$route.query['transactionId'])
                        }
                        this.dialogVisible =false
                        this.dataForm = {
                            proxyPersonName:'',
                            proxyPersonIC:'',
                            proxyPersonContactNo:'',
                            checked:'N'

                        }

                }
                catch (e) {

                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerPrintDetail.vue